import ModuleLoaderService, { ModuleType, type ModuleGroupsLoadingConfig } from '@ts/services/module-loader-service';

const loadDefaultJSModules = async () => {
    const SERVICE_MODULES: ModuleGroupsLoadingConfig = {
        moduleType: ModuleType.SERVICE,
        moduleGroups: [['alpine-init-service', 'back-to-top-button-init-service']],
    };

    await ModuleLoaderService.loadJSModules(SERVICE_MODULES);
};

const handleAllInitializersFinished = () => {
    globalThis.Alpine?.start();
};

const main = async () => {
    await loadDefaultJSModules();

    const { default: InitializerService } = await import('@ts/services/initializers-service');
    InitializerService.checkInitializers(handleAllInitializersFinished);
};

main();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
// @ts-ignore
if (import.meta.hot) {
    // @ts-ignore
    import.meta.hot.accept(() => {});
}
